import { Button, Stack } from "@mui/material";
import { useState } from "react";

interface IFilterDonut {
  setOption: (option: any) => void;
  optionsList: { key: string; value: any }[];
  active: string;
}

export default function FilterDonut({
  setOption,
  optionsList,
  active,
}: Readonly<IFilterDonut>) {
  const [disabled, setDisabled] = useState(false)

  const handleSetOptions = (itm:unknown) => {
    setOption(itm);
  }

  return (
    <Stack
      direction="row"
      justifyContent="start"
      gap="6px"
      alignItems="center"
      flexWrap="wrap"
    >
      {optionsList.map((itm, i) => (
        <Button
          onClick={() => setOption(itm.value)}
          variant={active == itm.key ? "active" : "outlinedText"}
          key={i}
        >
          {itm.key}
        </Button>
      ))}
    </Stack>
  );
}
